







































































import { Component, Ref } from 'vue-property-decorator'
import { getResultList } from '@/request/apis/TrajectoryAnalysisRequest'
import RouterHelper from '@/mixins/RouterHelper.vue'
import ModuleIntroduction from '@/components/common/ModuleIntroduction.vue'
import ModuleWrapper from '@/components/common/ModuleWrapper.vue'
import StickyButton from '@/components/common/StickyButton.vue'
import ResultWrapper from '@/components/common/ResultWrapper.vue'
import { getCirroUrl } from '@/request/apis/common'
import UpdateButton from '@/components/common/UpdateButton.vue'
import Gallery from '@/components/common/Gallery.vue'
import DropdownGroup from '@/components/common/DropdownGroup.vue'

@Component({
  components: {
    DropdownGroup,
    Gallery,
    StickyButton,
    UpdateButton,
    ResultWrapper,
    ModuleWrapper,
    ModuleIntroduction
  },
  beforeRouteUpdate (to, from, next) {
    next()
    // @ts-ignore
    this.getResult()
    // @ts-ignore
    this.getCirro()
  }
})

export default class TrajectoryAnalysisResult extends RouterHelper {
  @Ref('iframe-wrapper') iframe!: HTMLElement

  private cirroUrl: string = ''
  private imgDownloadUrl: string = ''
  private thumbList: any[] = []
  private thumbName: any[] = []
  private currentIndex: number = 0
  private resultList: any[] = ['PreProcessing']

  get id () {
    return this.$route.params.id
  }

  mounted () {
    this.getResult()
    this.getCirro()
  }

  /**
   * 获取结果数据并显示
   */
  private async getResult () {
    const result = await getResultList(null, this.id).start()
    this.imgDownloadUrl = result.images_download
    this.thumbList = result.images
    this.thumbName = this.thumbList.map((item: string) => {
      return decodeURIComponent(item.split('/')[item.split('/').length - 1].split('.')[0])
    })
  }

  /**
   * 获取cirro的链接，加载时loading
   */
  private async getCirro () {
    try {
      const getCirroRequest = getCirroUrl(this.iframe, { jobId: this.id, type: 'TrajectoryAnalysis' })
      this.cirroUrl = await getCirroRequest.start()
    } catch (e) {
      console.log(e)
    }
  }
}
